"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  sk: {
    shoppingCart: {
      actions: {
        addToCart: 'Pridať do košíka',
        buy: 'Kúpiť',
        order: 'Objednať',
        remove: 'Odstrániť'
      },
      cart: {
        total: {
          label: 'Celkom',
          helperText: '',
          helperTextPreview: ''
        },
        totalItems: {
          label: 'Celkom za položky',
          helperText: '',
          helperTextPreview: ''
        },
        totalShipping: {
          label: 'Celkom za dopravu',
          helperText: '',
          helperTextPreview: ''
        },
        totalPayment: {
          label: 'Celkom za platbu',
          helperText: '',
          helperTextPreview: ''
        },
        totalTaxes: {
          label: 'Daň celkom',
          helperText: '',
          helperTextPreview: ''
        },
        resetCart: 'Resetovať košík'
      },
      messages: {
        confirmResetCart: 'Ste si istý, že chcete zmazať obsah košíka?',
        giftClaim: 'Môžete získať {quantity} kusov {productName} ako darček.',
        cartManipulations: {
          allRemoved: 'Všetky položky košíka boli odstránené.',
          itemAdded: 'Do košíka {number, plural, one {bola pridaná položka} other {boli pridané položky}}.',
          itemRemoved: 'Z košíka {number, plural, one {bola odstránená položka} other {boli odstránené položky}}.',
          quantityChaged: 'Zmenilo sa zakúpené množstvo.'
        }
      },
      components: {
        appBartActionCart: 'Košík',
        quantityField: {
          states: {
            quantityRounded: 'Množstvo bolo zaokrúhlené na najbližšiu veľkosť balenia.'
          }
        },
        cartAsidePreview: {
          cartEmpty: 'Váš košík je prázdny'
        },
        cartAfterAddModal: {
          continueShopping: 'Pokračovať v nákupe',
          goToCart: 'Prejsť do košíka',
          title: 'Produkty pridané do košíka',
          pcs: 'ks'
        }
      }
    }
  }
};
var _default = messages;
exports.default = _default;